/* eslint-disable no-nested-ternary */

import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import { useIsBelowLargeOnly } from '../../hooks/mediaQueries';
import useCardView from '../../hooks/useCardView';
import { AcceptedRegions } from '../../utilities/locale-utilities';
import DesktopFinanceBanner from '../Banner/DesktopFinanceBanner';
import DesktopFinanceBannerSwitch24 from '../Banner/DesktopFinanceBannerSwitch24';
import MiddleBanner from '../Banner/MiddleBanner/MiddleBanner';
import DealsGridViewProductCard from '../ProductCard/DealsGridViewProductCard/DealsGridViewProductcard@default';
import ProductCardListView from '../Views/ProductCardListView/ProductCardListView@default';
import ProductCardMobileView from '../Views/ProductCardMobileView/ProductCardMobileView@default';
import Store from '../Views/store/store';
import DealsWeRecommendPod from './DealsWeRecommendPod';
import NoResultsCard from './NoResultsCard';

export const PaginatedProductList = () => {
	const { products, productCardView, isDealsPage, loading } = useSelector(
		(state) => state,
	);

	const { ShouldShowSwitchV2, MobileNonSwitchEnhancedCardEnabled } =
		useSelector((state) => state.featureSwitches);

	const { isGridView, isListView } = useCardView();

	let featuredProducts = 0;

	if (isDealsPage && isGridView) {
		featuredProducts = products.reduce(
			(acc, item, index) =>
				index <= 1 && item.IsFeaturedProduct ? ++acc : acc,
			0,
		);
	}

	if (products?.length <= 0 && !loading) {
		return <NoResultsCard />;
	}
	return (
		<section
			data-tag-section={`${isDealsPage ? 'deals' : 'lister'} product list`}
			data-tag-viewtype={productCardView ? productCardView : 'mobile'}>
			<ul
				className={classnames('flex flex-wrap -mb-2', {
					'pt-2': isGridView,
				})}>
				<DealsWeRecommendPod featuredProducts={featuredProducts} />

				{products.map((product, index) => {
					if (isDealsPage && index < featuredProducts) {
						return null;
					}
					let listItems = [];

					if (index === 1) {
						listItems.push(<div id="PLP-ConversationalSearch-Mid"></div>);
					}

					//lazy load, fallback with skeleton, move to @aol file
					listItems.push(
						<AcceptedRegions AOL key={uuidv4()}>
							{ShouldShowSwitchV2 ? (
								<DesktopFinanceBannerSwitch24 index={index} />
							) : (
								<DesktopFinanceBanner index={index} />
							)}
						</AcceptedRegions>,
					);

					listItems.push(<MiddleBanner key={uuidv4()} index={index} />);

					const productInfo = {
						key: `${index + 1}-${product.Code}`,
						index,
						product,
					};

					const isNotDealsOrIsListView = !isDealsPage || isListView;
					
					listItems.push(
						<Store state={{ loaded: index === 0 }}>
							{isNotDealsOrIsListView && (
								<ProductCardListView {...productInfo}/>								
							)}

							{isDealsPage && isGridView && (
								<DealsGridViewProductCard {...productInfo} />
							)}
						</Store>
					);

					return listItems;
				})}
			</ul>
		</section>
	);
};

export default PaginatedProductList;
